import { RouteProps } from 'routes/AppRouter'
import { AppointmentsTable } from 'features/extern-appointments'
import React from 'react'
import { useTitleHeaderContext } from 'common/utils/TitleHeaderContext'
import { Box } from '@mui/material'
import logoCareme from '../../assets/caremePlusLogo.svg'
import style from '../layout/Main.module.css'

export function ExternAppointmentsTable(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return (
    <>
      <AppointmentsTable />
      <Box display={'flex'} justifyContent={'flex-end'}>
        <img src={logoCareme} alt="Logo Careme" className={style.logo} />
      </Box>
    </>
  )
}
